import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function APY({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M17.0382 6.66671H15.3426L6.96163 17.3334H8.65729L17.0382 6.66671Z"
        fill={iconColor}
      />
      <Path
        d="M5.99992 9.33337C5.99992 7.97959 6.93594 6.66671 8.33325 6.66671C9.73056 6.66671 10.6666 7.97959 10.6666 9.33337C10.6666 10.6872 9.73056 12 8.33325 12C6.93594 12 5.99992 10.6872 5.99992 9.33337ZM8.33325 8.00004C7.88962 8.00004 7.33325 8.47802 7.33325 9.33337C7.33325 10.1887 7.88962 10.6667 8.33325 10.6667C8.77689 10.6667 9.33325 10.1887 9.33325 9.33337C9.33325 8.47802 8.77689 8.00004 8.33325 8.00004Z"
        fill={iconColor}
      />
      <Path
        d="M15.6666 12C14.2693 12 13.3333 13.3129 13.3333 14.6667C13.3333 16.0205 14.2693 17.3334 15.6666 17.3334C17.0639 17.3334 17.9999 16.0205 17.9999 14.6667C17.9999 13.3129 17.0639 12 15.6666 12ZM14.6666 14.6667C14.6666 13.8114 15.2229 13.3334 15.6666 13.3334C16.1102 13.3334 16.6666 13.8114 16.6666 14.6667C16.6666 15.5221 16.1102 16 15.6666 16C15.2229 16 14.6666 15.5221 14.6666 14.6667Z"
        fill={iconColor}
      />
      <Path
        d="M11.9999 1.33337C6.10888 1.33337 1.33325 6.109 1.33325 12C1.33325 17.8911 6.10888 22.6667 11.9999 22.6667C17.891 22.6667 22.6666 17.8911 22.6666 12C22.6666 6.109 17.891 1.33337 11.9999 1.33337ZM2.66659 12C2.66659 6.84538 6.84526 2.66671 11.9999 2.66671C17.1546 2.66671 21.3333 6.84538 21.3333 12C21.3333 17.1547 17.1546 21.3334 11.9999 21.3334C6.84526 21.3334 2.66659 17.1547 2.66659 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
